import { Link } from 'react-router-dom';

import styled from 'styled-components/macro';

import ButtonComponent from 'components/Button';
import { COLORS } from 'theme';

interface IStyleProps {
	isHighlighted: boolean;
}

export namespace Styled {
	export const Root = styled.section`
		position: relative;
		width: 100%;
		margin: 0;
		padding: 0;
	`;

	export const Wrapper = styled.span<IStyleProps>`
		color: ${({ isHighlighted }) => (isHighlighted ? COLORS.blue : COLORS.black)};
	`;

	export const Title = styled.span`
		display: block;
		width: 300px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	`;

	export const PageLink = styled(Link)`
		display: flex;
		line-height: 28px;
		min-width: 28px;
		font-weight: 500;
		color: ${COLORS.black};
		gap: 4px;

		span {
			color: ${COLORS.inputColor};
			text-decoration: underline;
			transition: all 0.2s ease;
		}

		&:hover,
		&:focus {
			span {
				text-decoration: none;
			}
		}
	`;

	export const Button = styled(ButtonComponent)`
		line-height: 28px;
		height: 28px;
		min-width: 28px;
		padding: 4px 8px;
		font-size: 14px;
		gap: 8px;

		span {
			display: flex;
			margin: 0;
		}
	`;
}
